<template lang="pug">
v-container(fluid).pa-0
  v-card(flat)
    v-row.mt-0.mb-1
      v-col(
        v-for="(i, idx) in pages"
        cols="12" md=4
        :key="idx"
      )
        v-card(
          flat
          :to="{ name: i.path }"
          active-class="dark-active"
        ).fill-height
          v-card-text.px-5.mb-0
            .text-body-1: strong {{ i.title }}
            .text-body-2  {{ i.subtitle }}

    router-view(
      :agreements="agreements"
    )

</template>
<script>
import { CONTRACT_TYPES } from './constants';

const agreements = {
  [CONTRACT_TYPES.ip]: {
    day_before_course_end: 0,
    type: 1,
    title: 'Договор оферта',
    is_offer: true,
    // disabled: true,
  },
  [CONTRACT_TYPES.ur]: {
    day_before_course_end: 0,
    title: 'Авто-договор',
    type: 2,
    is_offer: true,
  },
  [CONTRACT_TYPES.not_offer]: {
    type: 2,
    title: 'Договор на бумаге',
    is_offer: false,
    document: {
      url: null,
      file_name: null,
    },
  },
};

export default {
  data() {
    return {
      agreements: { ...agreements },

      pages: [
        {
          title: 'Реестр договоров',
          subtitle: 'об образовании',
          path: 'AgreementsList',
        },
        {
          title: 'Реестр удостоверений',
          subtitle: 'Выдача и просмотр',
          path: 'CertificateList',
        },
        {
          title: 'Настройки',
          subtitle: 'Бюрократия и типовые договоры',
          path: 'PaymentSettings',
        },
      ],
    };
  },
  computed: {
  },
  created() {
    this.fetchContracts();
  },
  methods: {
    async fetchContracts() {
      this.$loader.start();
      const params = {
        params: {
          expand: 'document,preview_document',
          'search[owner_id]': this.$user.data.id,
        },
      };
      const { data } = await this.$api.contracts.getTypicalContract(params);
      data.data.forEach((cur) => {
        const val = !cur.is_offer ? this.$conf.CONTRACT_TYPES.not_offer : cur.type;
        this.agreements[val] = { ...this.agreements[val], ...cur };
      });
      this.$loader.stop();
    },
    deleteAgreement(agremeentKey) {
      this.$emit('delete', agremeentKey);
      this.agreements[agremeentKey] = { ...agreements[agremeentKey] };
    },
  },
};
</script>
